<template>
  <div class="BlockList" v-show="floag">
    <div class="BlockList-W">
      <img
        class="imgs"
        src="../../../assets/pc/Login/close.png"
        @click="close1"
      />
      <div class="bindbox">
        <div class="bindcons">
          Confirm to log out of the current<br />
          account
        </div>
        <div class="bindbtn">
          <div class="botton" @click="close1">close</div>
          <div class="botton1" @click="Confirms">Confirm</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetLogin } from "@/assets/server/api";
import { getSubStr } from "@/utils/utils";
export default {
  props: ["lflog"],
  data() {
    return {
      floag: false,
      
    };
  },
  components: {},
  created() {},
  mounted() {},
  watch: {
    deep: true,
    lflog(val) {
      this.floag = val;
    },
  
  },
  methods: {
    close1(){
      this.floag=false;
      this.$emit('logouts',this.floag);
    },
    Confirms(){
      localStorage.removeItem("userId");
      localStorage.removeItem("email");
 
     // localStorage.removeItem("isBindAddress");
     this.$emit("email", "");
      this.floag=false;
      this.$emit('logouts',this.floag);
      this.$emit('loginflog',true);
      this.$message({
            message: 'Logout successful',
            type: "warning",
            customClass: "message-zindex",
          });
          window.location.reload()
      //@loginflog="loginflog($event)"
     // this.$emit("isBind", "");
    }
  },
};
</script>
<style lang="less">
/deep/.el-message {
  z-index: 99999999999 !important;
  background-color: #fff !important;
  /* 设置文本颜色为白色 */
  color: white !important;

  /* 其他样式调整，根据需要自行添加 */
}
</style>
<style lang="less" scoped>
.BlockList {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999999999999;
  // background: red;
  width: 100%;
  height: 100%;
  overflow: auto;
  .BlockList-W {
    width: 365px;
    height: 194px;
    background: #151515;
    border-radius: 10px 10px 10px 10px;
    position: absolute;
    z-index: 0 !important;
    // border: 1px solid red;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .imgs {
      width: 18px;
      height: 18px;
      margin-left: 335px;
      margin-top: 12px;
    }
    .bindbox {
    width: 305px;
    margin: 0 auto;

    .bindcons {
      margin-top: 10px;
      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
      line-height: 24px;
      text-align: center;
    }
    .bindbtn {
      display: flex;
      margin-top: 40px;
      .botton {
        width: 142px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        border-radius: 81px 81px 81px 81px;
        border: 1px solid #3cf6f0;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 15px;
        color: #3cf6f0;
        cursor: pointer;
      }
      .botton1 {
        width: 142px;
        height: 38px;
        background: #3cf6f0;
        border-radius: 81px 81px 81px 81px;
        line-height: 38px;
        text-align: center;
        cursor: pointer;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 15px;
        color: #151515;
        margin-left: 21px;
      }
    }
  }
  }
}
</style>
